const namespace = '[DISPATCH_EDIT]';
export const DISPATCH_EDIT_FETCH_DISPATCH = `${namespace} FETCH DISPATCH`;
export const DISPATCH_EDIT_SET_DISPATCH = `${namespace} SET DISPATCH`;
export const DISPATCH_EDIT_UPDATE_DISPATCH = `${namespace} UPDATE DISPATCH`;
export const DISPATCH_EDIT_SET_SAVING = `${namespace} SET SAVING`;
